
import { Vue } from "vue-class-component";

export default class WalletCod extends Vue {}
